import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_DS_ORGANIZATIONS_QUERY from './GetDSOrganizations.gql';
import { config } from '@uhg-abyss/web/tools/config';

const parseResult = (result) => {
  const initialState = {
    orgList: [],
  };

  const organizationsInfo = get(result, 'digitalsecurity.organizations');

  return {
    ...initialState,
    ...organizationsInfo,
  };
};

export const useDSOrganizationsQuery = (options) => {
  const [queryResult, queryAction] = useQuery(GET_DS_ORGANIZATIONS_QUERY, {
    ...options,
    requestPolicy: 'no-cache',
    url: config('DIGISEC_GRAPHQL_API_URL'),
    onCompleted: (result) => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
